<template>
  <!-- <div class="page">
        <div class="head-page">
            <div class="member-header p30">
                <el-button class="large-btn" type="primary" @click="addPage">新增</el-button>
            </div>
        </div>
        <div class="mains">
            <p class="title">额度总汇</p>
            <el-row class="rows">
                <el-col class="cols" :span="8">
                    <p class="van-text">充值上限</p>
                    <p class="van-label mt10 ">{{ amount.upperAmount }}</p>
                </el-col>
                <el-col class="cols" :span="8">
                    <p class="van-text">当月充值</p>
                    <p class="van-label mt10">{{ amount.currMonthRechargeTotalAmount }}</p>
                </el-col>
                <el-col class="cols" :span="8">
                    <p class="van-text">剩余额度</p>
                    <p class="van-label mt10" style="color: #02c346;">{{ amount.currMonthLeftRechargeAmount }}</p>
                </el-col>
            </el-row>
            <p class="title">申请记录</p>
            <div class="rows">
                <el-table :data="list" border>
                    <el-table-column prop="rechargeAmount" label="充值金额"></el-table-column>
                    <el-table-column prop="auditStatus" label="状态">
                        <template slot-scope="scope">
                            <span style="color: #2896fe;" v-if="scope.row.auditStatus == 'wait'">{{ scope.row.auditStatusCn }}</span>
                            <span style="color: #666;" v-if="scope.row.auditStatus == 'pass'">{{ scope.row.auditStatusCn }}</span>
                            <span style="color: #ee2e2e;" v-if="scope.row.auditStatus == 'refuse'">{{ scope.row.auditStatusCn }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="申请时间" min-width="150px">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.oxCtime) }}
                        </template>
                    </el-table-column>
                </el-table>
                <paging :totalCount="totalCount" @doPageQuery="doPageQuery"></paging>
            </div>
        </div>
        <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>-->
  <div class="page">
    <div class="head-page">
      <div class="member-header p30">
        <el-button class="large-btn" type="primary" @click="addPage()">新增</el-button>
      </div>
    </div>
    <div class="mains">
      <div class="rows">
        <el-table :data="list" border>
          <el-table-column prop="rechargeAmount" label="充值金额"></el-table-column>
          <el-table-column prop="auditStatus" label="状态">
            <template slot-scope="scope">
              <span
                style="color: #2896fe;"
                v-if="scope.row.auditStatus == 'wait'"
              >{{ scope.row.auditStatusCn }}</span>
              <span
                style="color: #666;"
                v-if="scope.row.auditStatus == 'pass'"
              >{{ scope.row.auditStatusCn }}</span>
              <span
                style="color: #ee2e2e;"
                v-if="scope.row.auditStatus == 'refuse'"
              >{{ scope.row.auditStatusCn }}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请时间" min-width="150px">
            <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
          </el-table-column>
        </el-table>
        <paging :totalCount="totalCount" @doPageQuery="doPageQuery"></paging>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
export default {
  mixins: [minxin],
  components: { editSet },
  data() {
    return {
      amount: {
        upperAmount: "",
        currMonthRechargeTotalAmount: "",
        currMonthLeftRechargeAmount: "" //销售业绩
      },
      url: this.$url.shopRechargeApply.page,
      query: {
        beginTime: new Date(),
        endTime: new Date()
      }
    };
  },

  created() {
    this.init();
  },
  methods: {
    init() {
      this.$api.post(this.$url.shopRechargeApply.getSet).then(res => {
        if (res) {
          this.amount = res;
        }
        this.getList();
      });
    },
    addPage() {
      this.$refs["editSetForm"].$emit("set");
      // this.$router.push(`/data/shopRecharge/edit`);
    },
    handleChange(bool) {
      if (bool) {
        this.init();
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ .el-input-group__append {
  background-color: #409eff;
  color: #fff;
}
/deep/ .input-with-select .el-input__inner {
  height: 56px !important;
}
/deep/ .input-with-select {
  font-size: 0.18rem;
}
.member-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 60px);
  box-sizing: border-box;
  .title-name {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-right: 62px;
  }
  .icon-search {
    font-size: 0.3rem;
  }
}
.page-head {
  display: flex;
  padding: 20px 30px;
  .times {
    align-items: center;
    display: flex;
  }
  .flex-row {
    margin-left: 10px;
    align-items: center;
    display: flex;
  }
}
.mains {
  .rows {
    padding: 0 30px 30px;
    // padding-bottom: 0;
    .cols {
      padding-bottom: 40px;
      .van-text {
        font-size: 0.18rem;
        font-weight: 500;
      }
      .van-label {
        font-size: 0.2rem;
        color: @red;
        margin-top: 10px;
      }
    }
  }
}
</style>